import { render, staticRenderFns } from "./DashboardFormation.vue?vue&type=template&id=45e9a01a&"
import script from "./DashboardFormation.vue?vue&type=script&lang=js&"
export * from "./DashboardFormation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports